import { ReduxStore } from "$redux/reducers";
import { CartTimeoutState } from "$redux/reducers/cartTimeoutReducer";
import { useSelector } from "react-redux";

export const useCartTimeoutSelector = () => {
    const cartTimeout = useSelector<ReduxStore, CartTimeoutState>((store) => store.cartTimeout);
    return { cartTimeout };
};
